import { render, staticRenderFns } from "./orderDetailInfoOld.vue?vue&type=template&id=d8e5b606"
import script from "./orderDetailInfoOld.vue?vue&type=script&lang=js"
export * from "./orderDetailInfoOld.vue?vue&type=script&lang=js"
import style0 from "./orderDetailInfoOld.vue?vue&type=style&index=0&id=d8e5b606&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports